import type { GistItem } from "../../model/types";
import { buildWorkspaceGistTree, getUniqueWorkspaceGists } from "./buildWorkspaceGistTree";
import type {
  WorkspaceNavigationCounts,
  WorkspaceNavigationCountsOptions,
} from "./workspaceNavigationTypes";

export function isWorkspaceDraftGist(gist: GistItem): boolean {
  return String(gist.status || "").toLowerCase() === "draft";
}

export function isWorkspacePublishedGist(gist: GistItem): boolean {
  return (
    String(gist.status || "").toLowerCase() === "published" ||
    Boolean(gist.publishedAt)
  );
}

export function getWorkspaceNavigationCounts(
  gists: GistItem[],
  options: WorkspaceNavigationCountsOptions = {},
): WorkspaceNavigationCounts {
  const uniqueGists = getUniqueWorkspaceGists(gists);
  const tree = buildWorkspaceGistTree(uniqueGists, {
    sortGists: options.sortGists,
  });
  const rootGists = tree.length;

  return {
    totalGists: uniqueGists.length,
    rootGists,
    replyGists: Math.max(0, uniqueGists.length - rootGists),
    draftGists: uniqueGists.filter(isWorkspaceDraftGist).length,
    publishedGists: uniqueGists.filter(isWorkspacePublishedGist).length,
    directSubjectGists:
      typeof options.selectedSubjectId === "number"
        ? uniqueGists.filter((gist) => gist.subjectId === options.selectedSubjectId).length
        : 0,
  };
}
